export default {
  getServerUri() {
    return process.env.VUE_APP_SERVER_URI;
  },
  getShopUri() {
    return process.env.VUE_APP_SHOP_URI;
  },
  getReteRicambiUri() {
    return process.env.VUE_APP_RETE_RICAMBI_URI || "https://rrapi.lekotech.com";
  },
  getReteRicambiFrontUri() {
    return process.env.VUE_APP_RETE_RICAMBI_FRONT_URI || "https://rr.lekotech.com";
  },
};
